<div [formGroup]="detailsForm" class="form-grid-secondary">
  <nz-form-item>
    <nz-form-label nzFor="resourceType" nzRequired>Resource Type</nz-form-label>
    <nz-form-control [nzErrorTip]="resourceTypeErrorTpl">
      <nz-select
        formControlName="resourceType"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzPlaceHolder="Select resource type"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('resourceType') ? 'error' : ''">
        <nz-option
          *ngFor="let item of behaviourResuorceType; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
      <ng-template #resourceTypeErrorTpl let-control>
        <div class="error-message">{{ getError('resourceType') }}</div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    *ngIf="
      detailsForm.get('resourceType')?.value === REPLACEMENT_BEHAVIOR_TYPE_ID
    ">
    <nz-form-label
      nzFor="replacementType"
      [nzRequired]="
        detailsForm.get('resourceType')?.value === REPLACEMENT_BEHAVIOR_TYPE_ID
      "
      >Replacement Type</nz-form-label
    >
    <nz-form-control [nzErrorTip]="replacementTypeErrorTpl">
      <nz-select
        formControlName="replacementType"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select Replacement Type"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('replacementType') ? 'error' : ''">
        <nz-option
          *ngFor="let item of behaviourReplacementType; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
      <ng-template #replacementTypeErrorTpl let-control>
        <div
          class="error-message"
          *ngIf="
            detailsForm.get('resourceType')?.value ===
              REPLACEMENT_BEHAVIOR_TYPE_ID && isInvalid('replacementType')
          ">
          {{ getError('replacementType') }}
        </div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item class="col-span">
    <nz-form-label nzFor="title" nzRequired>Title</nz-form-label>
    <nz-form-control [nzErrorTip]="titleErrorTpl">
      <input
        nz-input
        id="title"
        formControlName="title"
        placeholder="Enter title"
        [nzStatus]="isInvalid('title') ? 'error' : ''" />
      <ng-template #titleErrorTpl let-control>
        <div class="error-message">{{ getError('title') }}</div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item class="col-span">
    <nz-form-label nzFor="description" nzRequired>Description</nz-form-label>
    <nz-form-control [nzErrorTip]="descriptionErrorTpl">
      <textarea
        nz-input
        id="description"
        formControlName="description"
        rows="4"
        placeholder="Enter your text"
        [nzStatus]="isInvalid('description') ? 'error' : ''">
      </textarea>
      <div class="hint-text">{{ getCharacterCount('description') }}</div>
      <ng-template #descriptionErrorTpl let-control>
        <div class="error-message">{{ getError('description') }}</div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item class="col-span">
    <nz-form-label nzFor="languageLevel" nzRequired
      >Language Level</nz-form-label
    >
    <nz-form-control [nzErrorTip]="languageLevelErrorTpl">
      <nz-radio-group formControlName="languageLevel">
        <span nz-radio *ngFor="let level of languageLevel" [nzValue]="level.id">
          {{ level.name }}
        </span>
      </nz-radio-group>
      <ng-template #languageLevelErrorTpl let-control>
        <div class="error-message">{{ getError('languageLevel') }}</div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item class="col-span">
    <nz-form-label nzFor="supervisionType" nzRequired
      >Supervision Type</nz-form-label
    >
    <nz-form-control [nzErrorTip]="supervisionTypeErrorTpl">
      <nz-select
        formControlName="supervisionType"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzPlaceHolder="Select supervision type"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('supervisionType') ? 'error' : ''">
        <nz-option
          *ngFor="let item of behaviourSupervisionType; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
      <ng-template #supervisionTypeErrorTpl let-control>
        <div class="error-message">{{ getError('supervisionType') }}</div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-control class="col-span">
    <nz-form-item>
      <span nz-checkbox formControlName="isSettingEvent">Is Setting Event</span>
    </nz-form-item>
  </nz-form-control>

  <nz-form-control class="col-span">
    <nz-form-item>
      <span nz-checkbox formControlName="suitableForSchool"
        >Suitable For School</span
      >
    </nz-form-item>
  </nz-form-control>
</div>
